"use strict";
/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Support service for the menu component. Can be expanded.
 */
class MenuService {
    /**
     * Makes custom indexes for the MenuItems array for proper handling group items.
     *
     * @param {ReadonlyArray<MenuItemType>} data
     * @returns {MenuItemType[]} pack by name
     */
    setIndexes(data) {
        let tempIndex = 0;
        return data.map((item) => {
            if (!item.subItems || item.subItems.length === 0) {
                item.menuIndex = tempIndex;
                tempIndex = tempIndex + 1;
            }
            else {
                item.subItems = item.subItems.map((sub) => {
                    sub.menuIndex = tempIndex;
                    tempIndex = tempIndex + 1;
                    return sub;
                });
            }
            return item;
        });
    }
}
exports.MenuService = MenuService;
//# sourceMappingURL=menu.service.js.map